import React from "react";

function OverviewPage() {

  return (
    <>
      <section id="overview" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Overview</h2>

        </div>

        <div className="container" data-aos="fade" data-aos-delay="100">
          <div className="row justify-content-center">
            <p className="lead text-muted mb-4">
              SailorsData is a <strong>dynamic recruitment and career platform</strong> designed to connect maritime and offshore professionals with the right opportunities. Whether you’re a company seeking skilled crew or a candidate looking for your next assignment, SailorsData streamlines the hiring journey with modern tools, transparent processes, and a user-friendly interface.
            </p>
            <p className="text-secondary">
              Our mission is simple: to make hiring faster, smarter, and more effective by bridging the gap between employers and job seekers in the global shipping, oil &amp; gas, and offshore industries.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default OverviewPage;
